<div class="pricing">
  <div class="row">
    <div class="col-12 pricing-table-light">
      <div class="container-xl">
        <app-pricing-table></app-pricing-table>
        <!-- <div class="col-xs-12 smt16 smb0 haveClients">
          <div class="row clients align-items-center justify-content-between">
            <div class="col-auto">
              <img
                src="assets/images/client-logo/jpmorgan.png"
                alt="JP Morgan" />
            </div>
            <div class="col-auto">
              <img
                src="assets/images/client-logo/wallmart.png"
                alt="wallmart" />
            </div>
            <div class="col-auto">
              <img src="assets/images/client-logo/samsung.png" alt="samsung" />
            </div>
            <div class="col-auto">
              <img src="assets/images/client-logo/amazon.png" alt="amazon" />
            </div>
            <div class="col-auto">
              <img src="assets/images/client-logo/lenovo.png" alt="Lenovo" />
            </div>
            <div class="col-auto">
              <img
                src="assets/images/client-logo/microsoft.png"
                alt="Microsoft" />
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <app-transform-customer-service class="spa0 col-12" />
    <app-book-consultation [title]="title" class="spa0 col-12" />
  </div>
</div>
